import type { FunctionComponent } from 'react';
import { paletteHelper, Text, typographyHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { DialogModal } from '../../../../../app-kit/components/DialogModal/DialogModal';

interface NearbyPlanningPermitsDisclaimerProps {
  opened: boolean;
  onClose: () => void;
}

const BodyText = styled(Text)`
  ${typographyHelper('body01')};
  color: ${paletteHelper('textSecondary')};
`;

export const NearbyPlanningPermitsDisclaimer: FunctionComponent<
  NearbyPlanningPermitsDisclaimerProps
> = ({ opened, onClose }) => {
  return (
    <DialogModal
      opened={opened}
      onClose={onClose}
      title="Planning permit data"
      primaryButtonText="Got it"
      primaryButtonOnClick={onClose}
    >
      <BodyText>
        This information is an excerpt from publicly available council planning data, and may be
        subject to errors or change. Property.com.au makes no representations or warranties
        regarding the accuracy of this data. Please consult the issuing council(s) directly for the
        most up-to-date planning information.
      </BodyText>
    </DialogModal>
  );
};
